import { FiKey, FiUser } from "react-icons/fi";
import { BackgroudHelper, StyleButton } from "../components/Styled";
import Input from "../components/Input";
import Button from "../components/Button";
import Icon from "../components/Icon";
import logo from "../../images/radconnext-logo.png";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { login, setCurAuthen } from "../../features/UserProfie";
import { HttpJsonHeader } from "../../features/Environments";
import axios from "axios";
import { setReminder } from "../../features/UserActions";
import { decode, encode } from "js-base64";
import { FcBusinessman, FcKey } from "react-icons/fc";
import { Form } from "react-bootstrap";

import SpinningCircles from "react-loading-icons/dist/esm/components/spinning-circles";
import { useEffect } from "react";
import styled from "styled-components";
import { VersionService } from "../../model/version";

function Login() {
  const userRef = useRef();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [chkInfo, setChkInfo] = useState(false);
  const [errMesage, setErrMessage] = useState("");
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const checkVer = async () => {
    if ((await VersionService.IsCurrentVersion()) === false) {
      // console.log("version mismatch");
      alert("ระบบต้องการ RadConnext ต้องการโหลดอีกเครั้งเพื่อ update version");
      window.location.reload();
    }
  };

  useEffect(() => {
    //console.log("coming");

    checkVer();
    return () => {
      console.log("return");
    };
  }, []);

  const checkUser = () => {
    setLoading(true);
    axios
      .post(
        process.env.REACT_APP_API + "user/authen",
        {
          data: encode(
            JSON.stringify({ Username: username, Password: password }),
          ),
        },
        HttpJsonHeader,
      )
      .then((response) => {
        var result = JSON.parse(decode(response.data));
        dispatch(login(result));
        dispatch(
          setCurAuthen({ username: username, password: encode(password) }),
        );

        window.history.pushState({}, "", "/");
        if (chkInfo) {
          localStorage.setItem("raduser", encode(username + "XvEz" + password));
        }
        setLoading(false);
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
        dispatch(
          setReminder({
            show: true,
            message: "Username Not Found",
            type: "error",
          }),
        );
        setErrMessage("ไม่พบผู้ใช้งาน");
      });
  };

  // const FaceBookBackground =
  //   "linear-gradient(to right, #0546a0 0%, #663f86 100%)";
  // const InstagramBackground =
  //   "linear-gradient(to right, #a12ac4 0%, #ed586c 100%)";
  // const TwitterBackground =
  //   "linear-gradient(to right, #56c1e1 0%, #35a9ce 50%)";
  // const LineBackground = "linear-gradient(to right, #13df53 0%, #05a52d 50%)";
  // const GoogleBackground = "linear-gradient(to right, #0af 0%, #00a 50%)";

  return (
    <MainContainer>
      {/* <BackgroudHelper /> */}

      <LogoContainer>
        {/* LOGO  */}
        <img
          src={logo}
          alt=""
          style={{
            maxWidth: "350px",
            margin: "2rem 1rem 0.5rem 1em",
          }}
        />
        <VersionTag>V. {process.env.REACT_APP_VERSION}</VersionTag>
        <WelComeTag>ยินดีต้อนรับ เข้าสู่ระบบ</WelComeTag>
      </LogoContainer>

      <InputFrame>
        <InputGroup>
          <FiUser size={20} color="#38BDF8" style={styles.inputIcon} />
          <CustomInput
            // style={styles.inputText}
            onChange={(e) => {
              setUsername(e.target.value);
            }}
            ref={userRef}
            type="text"
            placeholder="UserName"
            required={true}
          />
        </InputGroup>

        <InputGroup>
          <FiKey size={20} color="#38BDF8" style={styles.inputIcon} />
          <CustomInput
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            type="password"
            placeholder="Password"
            required={true}
          />
        </InputGroup>

        <ForgetpassContainer>
          <Form.Check
            type="switch"
            label="จำรหัสผ่าน"
            defaultChecked={true}
            checked={chkInfo}
            onChange={(e) => {
              setChkInfo(e.target.checked);
            }}
          />

          <LabForgetPass>ลืมรหัสผ่าน?</LabForgetPass>
        </ForgetpassContainer>

        {/* <label style={{ color: "yellow" }}>{errMesage}</label> */}

        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            background: "transparent",
            marginBlockStart: "50px",
          }}
        >
          {loading ? (
            <SpinningCircles style={{ flex: "1" }} />
          ) : (
            <Button
              content="Log In"
              onClick={() => {
                checkUser();
              }}
            />
          )}
        </div>
      </InputFrame>
    </MainContainer>
  );
}
// ascii=96 `
export default Login;

const styles = {
  inputIcon: {
    position: "absolute",
    color: "#38BDF8",
    left: "18px",
    top: "50%",
    transform: "translateY(-50%)",
  },
};

const MainContainer = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 500px;
  /* padding: 42px 136px; */
  padding-block: 80px 80px;
  padding-inline: 50px;
  background: rgba(13, 21, 38, 0.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(56, 189, 248, 0.3);
  border-radius: 24px;
  box-shadow:
    0 30px 60px -12px rgba(0, 0, 0, 0.7),
    0 0 40px rgba(14, 165, 233, 0.25);
  text-align: center;
`;

const WelComeTag = styled.div`
  color: #f8fafc;
  font-size: 20px;
  letter-spacing: 0.5px;
  margin-block: 10px 50px;
`;

const VersionTag = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 500;
  color: #38bdf8;
  background: rgba(14, 165, 233, 0.12);
  padding: 3px 12px;
  border-radius: 20px;
  border: 1px solid rgba(56, 189, 248, 0.3);
  margin-bottom: 22px;
  letter-spacing: 0.5px;
`;

const LabForgetPass = styled.label`
  cursor: pointer;
  :hover {
    color: yellow;
  }
`;

const LogoContainer = styled.div`
  display: block;
`;

const InputFrame = styled.div``;
const CustomInput = styled.input`
  padding: 14px 16px 14px 48px;
  background: rgba(22, 32, 54, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  color: #f8fafc;
  font-size: 14px;
  outline: none;
  transition: all 0.8s ease;
  -webkit-text-fill-color: #f8fafc;
  width: 100%;
  :focus {
    border-color: #38bdf8;
    background: rgba(22, 32, 54, 0.95);
    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.25);
    outline: none;
  }

  /* ::placeholder {
    color: #64748b;
  } */
`;

const InputGroup = styled.div`
  position: relative;
  margin-bottom: 18px;
  text-align: left;
  /* border: 1px solid yellow; */
`;

const ForgetpassContainer = styled.div`
  display: flex;
  color: #38bdf8;
  font-size: 14px;
  width: 100%;
  justify-content: space-between;
  /* border: 1px solid red; */
`;
